import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/shared/api/client';
import type { ApiResponse } from '@/features/auth/types/auth.types';
import type { CompanyUser } from '../types/company-admin.types';
import { mapUserResponse, type UserResponse } from './companyUsersMapper';

interface UseCompanyUsersReturn {
  users: CompanyUser[];
  hasData: boolean;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useCompanyUsers(companyId: string | undefined): UseCompanyUsersReturn {
  const query = useQuery({
    queryKey: ['company-users', companyId],
    queryFn: async () => {
      const response = await apiClient<ApiResponse<UserResponse[]>>('/auth/users');
      return response.data.map(mapUserResponse);
    },
    enabled: !!companyId,
  });

  const users = query.data?.filter((user) => !user.roles.includes('SUPER_ADMIN')) ?? [];

  return {
    users,
    hasData: query.data !== undefined,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
